import React from 'react';
import { Helmet } from 'react-helmet';
import { Typography, Box, Container } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { getCanonicalUrl } from '../utils/canonicalUrl';
import { marked } from 'marked';
import posts from '../content/resourcesPosts';

export default function Resources() {
  const location = useLocation();
  const canonicalUrl = getCanonicalUrl(location.pathname);
  return (
    <Box sx={{ color: 'common.white', '& .on-orange': { color: 'primary.main' } }}>
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
        <title>Resources & Insights</title>
        <meta name="description" content="Articles and case studies on applying pragmatic AI." />
        <meta property="og:title" content="Resources & Insights" />
        <meta property="og:description" content="Read our latest articles and success stories about AI." />
        <meta property="og:image" content="/assets/visuals/re-profile-blue-ai-hud.webp" />
      </Helmet>
      <Box
        sx={{
          position: 'relative',
          backgroundImage:
            'linear-gradient(rgba(24,45,70,0.8), rgba(53,85,111,0.8)), url("/assets/visuals/re-profile-blue-ai-hud.webp")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          textAlign: 'center',
          py: { xs: 8, md: 12 },
        }}
      >
        <Container>
          <Typography variant="h2" component="h1" gutterBottom>
            Resources & Insights
          </Typography>
        </Container>
      </Box>
      {posts.map((post, index) => (
        <Box
          key={post.id}
          component="section"
          sx={{
            mb: { xs: 4, md: 8 },
            px: { xs: 2, md: 6 },
            py: { xs: 4, md: 6 },
            backgroundColor: index % 2 === 0 ? 'primary.dark' : 'primary.main',
            textAlign: { xs: 'left', md: index % 2 === 0 ? 'left' : 'right' },
            '& ul': {
              listStylePosition: index % 2 === 0 ? 'outside' : 'inside',
              paddingLeft: index % 2 === 0 ? '1.5rem' : 0,
            },
          }}
        >
          <Typography variant="h6" component="h2" gutterBottom>
            {post.title}
          </Typography>
          <Box dangerouslySetInnerHTML={{ __html: marked(post.content) }} />
        </Box>
      ))}
    </Box>
  );
}
